import vars from '../helpers';

const newsItem = document.querySelectorAll('.news__item');
const popup = document.querySelector('.popup#news');
const popupContent = popup.querySelector('.popup__content');
const popupImage = popup.querySelector('.popup__image');
const popupTitle = popup.querySelector('.popup__title');
const popupText = popup.querySelector('.popup__text');
const popupClose = popup.querySelectorAll('.popup__close, .popup__overlay');
let pictureClone = null;

let popupTl = gsap.timeline();

const popupOpen = (item) => {
	popupTl.from(popup, {
		onStart() {
			scrollLock.disablePageScroll(popupContent);
			popup.classList.remove('is-hidden');
			popupTitle.innerHTML = item.dataset.title;
			popupText.innerHTML = item.dataset.text;

			if (item.querySelector('picture')) {
				pictureClone = item.querySelector('picture').cloneNode(true);
				popupImage.appendChild(pictureClone);
			}
		},
		duration: 0.3,
		opacity: 0,
		ease: 'power2.out',
		clearProps: 'all',
	});
};

const popupClosed = () => {
	popupTl.to(popup, {
		onComplete() {
			scrollLock.enablePageScroll(popupContent);
			popup.classList.add('is-hidden');
			popupTitle.innerHTML = '';
			popupText.innerHTML = '';

			if (pictureClone !== null) {
				popupImage.removeChild(pictureClone);
				pictureClone = null;
			}
		},
		duration: 0.3,
		opacity: 0,
		ease: 'power2.out',
		clearProps: 'all',
	});
};

const popupInit = () => {
	newsItem.forEach((item) => {
		item.addEventListener('click', () => {
			popupOpen(item);
		});
	});

	popupClose.forEach((close) => {
		close.addEventListener('click', () => {
			popupClosed();
		});
	});
};

export default popupInit;
